import { Pipe, PipeTransform } from '@angular/core'
import { ISection } from '@mmx/shared'
import { includes } from 'lodash'

@Pipe({
  name: 'customSections',
  standalone: false,
})
export class CustomSectionsPipe implements PipeTransform {
  builtInSections: string[] = [
    'Welcome',
    'Patient Information',
    'Insurance',
    'Employer',
    'Primary Care Physician',
    'Accident Information',
    'Emergency Contact',
    'Reason For Visit',
  ]

  transform(allSections: ISection[]): any {
    return allSections.filter(
      (section) => !includes(this.builtInSections, section.label),
    )
  }
}
